var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcEye12 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 18,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.191 9.043c.5-.963 2-3.293 4.815-3.293 2.841 0 4.322 2.319 4.817 3.291a.58.58 0 0 1-.003.53c-.5.963-2 3.293-4.814 3.293-2.842 0-4.323-2.32-4.817-3.292a.58.58 0 0 1 .002-.53Zm2.9.264c0 1.09.858 1.976 1.915 1.976s1.915-.885 1.915-1.976q0-.181-.031-.353c-.2.217-.484.353-.798.353-.609 0-1.102-.51-1.102-1.138 0-.318.126-.605.33-.812a2 2 0 0 0-.314-.026c-1.057 0-1.915.885-1.915 1.976",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcEye12);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };